import React from 'react'
import { processNan } from 'helpers/numberHelper'
import { SingleWrapper, LeftBtn, RightBtn, InputField } from './styles'

const SectionInput = ({ fn, field, val }) => {
  return (
    <SingleWrapper>
      <LeftBtn
        btnTxt='-'
        onClick={() => fn(processNan(parseInt(val) - 1), field)}
      />
      <InputField
        onChangeVal={e => fn(processNan(parseInt(e.target.value)), field)}
        value={val}
      />
      <RightBtn
        btnTxt='+'
        onClick={() => fn(processNan(parseInt(val) + 1), field)}
      />
    </SingleWrapper>
  )
}

export default SectionInput
